module.exports = __webpack_public_path__ + "img/fi-rr-eye-open.8a13759b.svg";